import { useMemo } from 'react';
import { useError } from 'react-use';

import { useRestPostQuery } from 'utils/hooks/api/useRestPostQuery';
import { ConversionRequest, ConversionResponse } from '../../types';

import { useInsightsResponseHandler } from './useInsightsResponseHandler';

const CONVERSIONS_API = '/lists/insights/conversion';

export const useConversionInsightsQuery = ({
  emailListId,
  searchQuery,
  startDate,
  endDate,
  page,
  pageSize,
  eventName,
}: ConversionRequest) => {
  const params = useMemo(
    () => ({
      emailListId,
      searchQuery,
      startDate,
      endDate,
      page,
      pageSize,
      eventName,
    }),
    [emailListId, searchQuery, startDate, endDate, page, pageSize, eventName],
  );
  const { handleResponse, data, isRetrying } = useInsightsResponseHandler<ConversionResponse>();
  const { refetch, isLoading, isError, isSuccess } = useRestPostQuery<
    ConversionResponse,
    ConversionRequest
  >(
    CONVERSIONS_API,
    params,
    {
      retry: (failureCount, error) => error.response?.status === 206,
      enabled: false,
      onError: useError(),
    },
    undefined,
    handleResponse,
  );

  return {
    data,
    refetch,
    isLoading: isLoading && !isRetrying,
    isSuccess,
    isError,
  };
};
